import { cx } from '../../lib/cx';
import { useT } from '../../lib/i18n';
import { commonMessages } from '../../lib/i18n/messages/common';

export function Skeleton({ className }: { className?: string }) {
  return <span aria-hidden className={cx('skeleton block', className)} />;
}

/** Row-shaped placeholders inside a card (DESIGN 3.4 Loading). */
export function SkeletonRows({ count = 3, className }: { count?: number; className?: string }) {
  const t = useT(commonMessages);
  return (
    <div className={cx('card overflow-hidden', className)} role="status" aria-label={t('loading')}>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={cx('row', i > 0 && 'border-t border-line')}>
          <Skeleton className="h-11 w-11 !rounded-control" />
          <span className="flex flex-1 flex-col gap-2">
            <Skeleton className="h-4 w-2/5" />
            <Skeleton className="h-3 w-3/5" />
          </span>
          <Skeleton className="h-4 w-14" />
        </div>
      ))}
    </div>
  );
}
